!(function (i) {
    "use strict";
    "function" == typeof define && define.amd ? define(["jquery"], i) : "undefined" != typeof exports ? (module.exports = i(require("jquery"))) : i(jQuery);
})(function (i) {
    "use strict";
    var e,
        t = window.Slick || {};
    (e = 0),
        ((t = function (t, o) {
            var s,
                n = this;
            (n.defaults = {
                adaptiveHeight: !1,
                appendArrows: i(t),
                appendDots: i(t),
                arrows: !0,
                arrowsPlacement: null,
                asNavFor: null,
                prevArrow: '<button class="slick-prev" type="button"><span class="slick-prev-icon" aria-hidden="true"></span><span class="slick-sr-only">Previous</span></button>',
                nextArrow: '<button class="slick-next" type="button"><span class="slick-next-icon" aria-hidden="true"></span><span class="slick-sr-only">Next</span></button>',
                autoplay: !1,
                autoplaySpeed: 3e3,
                centerMode: !1,
                centerPadding: "50px",
                cssEase: "ease",
                customPaging: function (e, t) {
                    return i('<button type="button"><span class="slick-dot-icon" aria-hidden="true"></span><span class="slick-sr-only">Go to slide ' + (t + 1) + "</span></button>");
                },
                dots: !1,
                dotsClass: "slick-dots",
                draggable: !0,
                easing: "linear",
                edgeFriction: 0.35,
                fade: !1,
                infinite: !0,
                initialSlide: 0,
                instructionsText: null,
                lazyLoad: "ondemand",
                mobileFirst: !1,
                playIcon: '<span class="slick-play-icon" aria-hidden="true"></span>',
                pauseIcon: '<span class="slick-pause-icon" aria-hidden="true"></span>',
                pauseOnHover: !0,
                pauseOnFocus: !0,
                pauseOnDotsHover: !1,
                regionLabel: "carousel",
                respondTo: "window",
                responsive: null,
                rows: 1,
                rtl: !1,
                slide: "",
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: !0,
                swipeToSlide: !1,
                touchMove: !0,
                touchThreshold: 5,
                useAutoplayToggleButton: !0,
                useCSS: !0,
                useGroupRole: !0,
                useTransform: !0,
                variableWidth: !1,
                vertical: !1,
                verticalSwiping: !1,
                waitForAnimate: !0,
                zIndex: 1e3,
            }),
                (n.initials = {
                    animating: !1,
                    dragging: !1,
                    autoPlayTimer: null,
                    currentDirection: 0,
                    currentLeft: null,
                    currentSlide: 0,
                    direction: 1,
                    $dots: null,
                    $instructionsText: null,
                    listWidth: null,
                    listHeight: null,
                    loadIndex: 0,
                    $nextArrow: null,
                    $pauseButton: null,
                    $pauseIcon: null,
                    $playIcon: null,
                    $prevArrow: null,
                    scrolling: !1,
                    slideCount: null,
                    slideWidth: null,
                    $slideTrack: null,
                    $slides: null,
                    sliding: !1,
                    slideOffset: 0,
                    swipeLeft: null,
                    swiping: !1,
                    $list: null,
                    touchObject: {},
                    transformsEnabled: !1,
                    unslicked: !1,
                }),
                i.extend(n, n.initials),
                (n.activeBreakpoint = null),
                (n.animType = null),
                (n.animProp = null),
                (n.breakpoints = []),
                (n.breakpointSettings = []),
                (n.cssTransitions = !1),
                (n.focussed = !1),
                (n.interrupted = !1),
                (n.hidden = "hidden"),
                (n.paused = !0),
                (n.positionProp = null),
                (n.respondTo = null),
                (n.rowCount = 1),
                (n.shouldClick = !0),
                (n.$slider = i(t)),
                (n.$slidesCache = null),
                (n.transformType = null),
                (n.transitionType = null),
                (n.visibilityChange = "visibilitychange"),
                (n.windowWidth = 0),
                (n.windowTimer = null),
                (s = i(t).data("slick") || {}),
                (n.options = i.extend({}, n.defaults, o, s)),
                (n.currentSlide = n.options.initialSlide),
                (n.originalSettings = n.options),
                void 0 !== document.mozHidden ? ((n.hidden = "mozHidden"), (n.visibilityChange = "mozvisibilitychange")) : void 0 !== document.webkitHidden && ((n.hidden = "webkitHidden"), (n.visibilityChange = "webkitvisibilitychange")),
                (n.autoPlay = i.proxy(n.autoPlay, n)),
                (n.autoPlayClear = i.proxy(n.autoPlayClear, n)),
                (n.autoPlayIterator = i.proxy(n.autoPlayIterator, n)),
                (n.autoPlayToggleHandler = i.proxy(n.autoPlayToggleHandler, n)),
                (n.changeSlide = i.proxy(n.changeSlide, n)),
                (n.clickHandler = i.proxy(n.clickHandler, n)),
                (n.selectHandler = i.proxy(n.selectHandler, n)),
                (n.setPosition = i.proxy(n.setPosition, n)),
                (n.swipeHandler = i.proxy(n.swipeHandler, n)),
                (n.dragHandler = i.proxy(n.dragHandler, n)),
                (n.instanceUid = e++),
                (n.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
                n.registerBreakpoints(),
                n.init(!0);
        }).prototype.addSlide = t.prototype.slickAdd = function (e, t, o) {
            var s = this;
            if ("boolean" == typeof t) (o = t), (t = null);
            else if (t < 0 || t >= s.slideCount) return !1;
            s.unload(),
                "number" == typeof t
                    ? 0 === t && 0 === s.$slides.length
                        ? i(e).appendTo(s.$slideTrack)
                        : o
                        ? i(e).insertBefore(s.$slides.eq(t))
                        : i(e).insertAfter(s.$slides.eq(t))
                    : !0 === o
                    ? i(e).prependTo(s.$slideTrack)
                    : i(e).appendTo(s.$slideTrack),
                (s.$slides = s.$slideTrack.children(this.options.slide)),
                s.$slideTrack.children(this.options.slide).detach(),
                s.$slideTrack.append(s.$slides),
                s.$slides.each(function (e, t) {
                    i(t).attr("data-slick-index", e), i(t).attr("role", "group"), i(t).attr("aria-label", "slide " + e);
                }),
                (s.$slidesCache = s.$slides),
                s.reinit();
        }),
        (t.prototype.animateHeight = function () {
            var i = this;
            if (1 === i.options.slidesToShow && !0 === i.options.adaptiveHeight && !1 === i.options.vertical) {
                var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
                i.$list.animate({ height: e }, i.options.speed);
            }
        }),
        (t.prototype.animateSlide = function (e, t) {
            var o = {},
                s = this;
            s.animateHeight(),
                !0 === s.options.rtl && !1 === s.options.vertical && (e = -e),
                !1 === s.transformsEnabled
                    ? !1 === s.options.vertical
                        ? s.$slideTrack.animate({ left: e }, s.options.speed, s.options.easing, t)
                        : s.$slideTrack.animate({ top: e }, s.options.speed, s.options.easing, t)
                    : !1 === s.cssTransitions
                    ? (!0 === s.options.rtl && (s.currentLeft = -s.currentLeft),
                      i({ animStart: s.currentLeft }).animate(
                          { animStart: e },
                          {
                              duration: s.options.speed,
                              easing: s.options.easing,
                              step: function (i) {
                                  (i = Math.ceil(i)), !1 === s.options.vertical ? ((o[s.animType] = "translate(" + i + "px, 0px)"), s.$slideTrack.css(o)) : ((o[s.animType] = "translate(0px," + i + "px)"), s.$slideTrack.css(o));
                              },
                              complete: function () {
                                  t && t.call();
                              },
                          }
                      ))
                    : (s.applyTransition(),
                      (e = Math.ceil(e)),
                      !1 === s.options.vertical ? (o[s.animType] = "translate3d(" + e + "px, 0px, 0px)") : (o[s.animType] = "translate3d(0px," + e + "px, 0px)"),
                      s.$slideTrack.css(o),
                      t &&
                          setTimeout(function () {
                              s.disableTransition(), t.call();
                          }, s.options.speed));
        }),
        (t.prototype.getNavTarget = function () {
            var e = this.options.asNavFor;
            return e && null !== e && (e = i(e).not(this.$slider)), e;
        }),
        (t.prototype.asNavFor = function (e) {
            var t = this.getNavTarget();
            null !== t &&
                "object" == typeof t &&
                t.each(function () {
                    var t = i(this).slick("getSlick");
                    t.unslicked || t.slideHandler(e, !0);
                });
        }),
        (t.prototype.applyTransition = function (i) {
            var e = this,
                t = {};
            !1 === e.options.fade ? (t[e.transitionType] = e.transformType + " " + e.options.speed + "ms " + e.options.cssEase) : (t[e.transitionType] = "opacity " + e.options.speed + "ms " + e.options.cssEase),
                !1 === e.options.fade ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t);
        }),
        (t.prototype.autoPlay = function () {
            var i = this;
            i.autoPlayClear(), i.slideCount > i.options.slidesToShow && (i.autoPlayTimer = setInterval(i.autoPlayIterator, i.options.autoplaySpeed));
        }),
        (t.prototype.autoPlayClear = function () {
            this.autoPlayTimer && clearInterval(this.autoPlayTimer);
        }),
        (t.prototype.autoPlayIterator = function () {
            var i = this,
                e = i.currentSlide + i.options.slidesToScroll;
            i.paused ||
                i.interrupted ||
                i.focussed ||
                (!1 === i.options.infinite &&
                    (1 === i.direction && i.currentSlide + 1 === i.slideCount - 1 ? (i.direction = 0) : 0 === i.direction && ((e = i.currentSlide - i.options.slidesToScroll), i.currentSlide - 1 == 0 && (i.direction = 1))),
                i.slideHandler(e));
        }),
        (t.prototype.autoPlayToggleHandler = function () {
            var i = this;
            i.paused
                ? (i.$playIcon.css("display", "none"),
                  i.$pauseIcon.css("display", "inline"),
                  i.$pauseButton.find(".slick-play-text").attr("style", "display: none"),
                  i.$pauseButton.find(".slick-pause-text").removeAttr("style"),
                  i.slickPlay())
                : (i.$playIcon.css("display", "inline"),
                  i.$pauseIcon.css("display", "none"),
                  i.$pauseButton.find(".slick-play-text").removeAttr("style"),
                  i.$pauseButton.find(".slick-pause-text").attr("style", "display: none"),
                  i.slickPause());
        }),
        (t.prototype.buildArrows = function () {
            var e = this;
            if (!0 === e.options.arrows)
                if (((e.$prevArrow = i(e.options.prevArrow).addClass("slick-arrow")), (e.$nextArrow = i(e.options.nextArrow).addClass("slick-arrow")), e.slideCount > e.options.slidesToShow)) {
                    if (e.htmlExpr.test(e.options.prevArrow))
                        if (null != e.options.arrowsPlacement)
                            switch (e.options.arrowsPlacement) {
                                case "beforeSlides":
                                case "split":
                                    e.$prevArrow.prependTo(e.options.appendArrows);
                                    break;
                                case "afterSlides":
                                    e.$prevArrow.appendTo(e.options.appendArrows);
                            }
                        else e.$prevArrow.prependTo(e.options.appendArrows);
                    if (e.htmlExpr.test(e.options.nextArrow))
                        if (null != e.options.arrowsPlacement)
                            switch (e.options.arrowsPlacement) {
                                case "beforeSlides":
                                    e.$prevArrow.after(e.$nextArrow);
                                    break;
                                case "afterSlides":
                                case "split":
                                    e.$nextArrow.appendTo(e.options.appendArrows);
                            }
                        else e.$nextArrow.appendTo(e.options.appendArrows);
                    !0 !== e.options.infinite && e.$prevArrow.addClass("slick-disabled").prop("disabled", !0);
                } else e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").prop("disabled", !0);
        }),
        (t.prototype.buildDots = function () {
            var e,
                t,
                o = this;
            if (!0 === o.options.dots && o.slideCount > o.options.slidesToShow) {
                for (o.$slider.addClass("slick-dotted"), t = i("<ul />").addClass(o.options.dotsClass), e = 0; e <= o.getDotCount(); e += 1) t.append(i("<li />").append(o.options.customPaging.call(this, o, e)));
                (o.$dots = t.appendTo(o.options.appendDots)), o.$dots.find("li").first().addClass("slick-active");
            }
        }),
        (t.prototype.buildOut = function () {
            var e = this;
            (e.$slides = e.$slider.children(e.options.slide + ":not(.slick-cloned)").addClass("slick-slide")),
                (e.slideCount = e.$slides.length),
                e.$slides.each(function (t, o) {
                    i(o)
                        .attr("data-slick-index", t)
                        .data("originalStyling", i(o).attr("style") || ""),
                        e.options.useGroupRole &&
                            i(o)
                                .attr("role", "group")
                                .attr("aria-label", "slide " + (t + 1));
                }),
                e.$slider.addClass("slick-slider"),
                e.$slider.addClass("accessible-slick"),
                e.$slider.attr("role", "region"),
                e.$slider.attr("aria-label", e.options.regionLabel),
                e.$slider.attr("tabindex", -1),
                (e.$slideTrack = 0 === e.slideCount ? i('<div class="slick-track"/>').appendTo(e.$slider) : e.$slides.wrapAll('<div class="slick-track"/>').parent()),
                (e.$list = e.$slideTrack.wrap('<div class="slick-list"/>').parent()),
                e.$slideTrack.css("opacity", 1),
                (!0 !== e.options.centerMode && !0 !== e.options.swipeToSlide) || (e.options.slidesToScroll = 1),
                i("img[data-lazy]", e.$slider).not("[src]").addClass("slick-loading"),
                e.setupInfinite(),
                e.buildArrows(),
                e.buildDots(),
                e.updateDots(),
                e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0),
                !0 === e.options.draggable && e.$list.addClass("draggable"),
                e.options.autoplay &&
                    e.options.useAutoplayToggleButton &&
                    e.slideCount > 1 &&
                    ((e.$pauseIcon = i(e.options.pauseIcon).attr("aria-hidden", !0)),
                    (e.$playIcon = i(e.options.playIcon).attr("aria-hidden", !0)),
                    (e.$pauseButton = i('<button type="button" class="slick-autoplay-toggle-button">')),
                    e.$pauseButton.append(e.$pauseIcon),
                    e.$pauseButton.append(e.$playIcon.css("display", "none")),
                    e.$pauseButton.append(i('<span class="slick-pause-text slick-sr-only">Pause Carousel</span>')),
                    e.$pauseButton.append(i('<span class="slick-play-text slick-sr-only" style="display: none">Play Carousel</span>')),
                    e.$pauseButton.prependTo(e.$slider)),
                null != e.options.instructionsText &&
                    "" != e.options.instructionsText &&
                    ((e.$instructionsText = i('<p class="slick-instructions slick-sr-only">' + e.options.instructionsText + "</p>")), e.$instructionsText.prependTo(e.$slider));
        }),
        (t.prototype.buildRows = function () {
            var i,
                e,
                t,
                o,
                s,
                n,
                l,
                r = this;
            if (((o = document.createDocumentFragment()), (n = r.$slider.children()), r.options.rows > 0)) {
                for (l = r.options.slidesPerRow * r.options.rows, s = Math.ceil(n.length / l), i = 0; i < s; i++) {
                    var a = document.createElement("div");
                    for (e = 0; e < r.options.rows; e++) {
                        var d = document.createElement("div");
                        for (t = 0; t < r.options.slidesPerRow; t++) {
                            var p = i * l + (e * r.options.slidesPerRow + t);
                            n.get(p) && d.appendChild(n.get(p));
                        }
                        a.appendChild(d);
                    }
                    o.appendChild(a);
                }
                r.$slider.empty().append(o),
                    r.$slider
                        .children()
                        .children()
                        .children()
                        .css({ width: 100 / r.options.slidesPerRow + "%", display: "inline-block" });
            }
        }),
        (t.prototype.checkResponsive = function (e, t) {
            var o,
                s,
                n,
                l = this,
                r = !1,
                a = l.$slider.width(),
                d = window.innerWidth || i(window).width();
            if (("window" === l.respondTo ? (n = d) : "slider" === l.respondTo ? (n = a) : "min" === l.respondTo && (n = Math.min(d, a)), l.options.responsive && l.options.responsive.length && null !== l.options.responsive)) {
                for (o in ((s = null), l.breakpoints)) l.breakpoints.hasOwnProperty(o) && (!1 === l.originalSettings.mobileFirst ? n < l.breakpoints[o] && (s = l.breakpoints[o]) : n > l.breakpoints[o] && (s = l.breakpoints[o]));
                null !== s
                    ? null !== l.activeBreakpoint
                        ? (s !== l.activeBreakpoint || t) &&
                          ((l.activeBreakpoint = s),
                          "unslick" === l.breakpointSettings[s] ? l.unslick(s) : ((l.options = i.extend({}, l.originalSettings, l.breakpointSettings[s])), !0 === e && (l.currentSlide = l.options.initialSlide), l.refresh(e)),
                          (r = s))
                        : ((l.activeBreakpoint = s),
                          "unslick" === l.breakpointSettings[s] ? l.unslick(s) : ((l.options = i.extend({}, l.originalSettings, l.breakpointSettings[s])), !0 === e && (l.currentSlide = l.options.initialSlide), l.refresh(e)),
                          (r = s))
                    : null !== l.activeBreakpoint && ((l.activeBreakpoint = null), (l.options = l.originalSettings), !0 === e && (l.currentSlide = l.options.initialSlide), l.refresh(e), (r = s)),
                    e || !1 === r || l.$slider.trigger("breakpoint", [l, r]);
            }
        }),
        (t.prototype.changeSlide = function (e, t) {
            var o,
                s,
                n = this,
                l = i(e.currentTarget);
            switch ((l.is("a") && e.preventDefault(), l.is("li") || (l = l.closest("li")), (o = n.slideCount % n.options.slidesToScroll != 0 ? 0 : (n.slideCount - n.currentSlide) % n.options.slidesToScroll), e.data.message)) {
                case "previous":
                    (s = 0 === o ? n.options.slidesToScroll : n.options.slidesToShow - o), n.slideCount > n.options.slidesToShow && n.slideHandler(n.currentSlide - s, !1, t);
                    break;
                case "next":
                    (s = 0 === o ? n.options.slidesToScroll : o), n.slideCount > n.options.slidesToShow && n.slideHandler(n.currentSlide + s, !1, t);
                    break;
                case "index":
                    var r = 0 === e.data.index ? 0 : e.data.index || l.index() * n.options.slidesToScroll;
                    n.slideHandler(n.checkNavigable(r), !1, t), l.children().trigger("focus");
                    break;
                default:
                    return;
            }
        }),
        (t.prototype.checkNavigable = function (i) {
            var e, t;
            if (((t = 0), i > (e = this.getNavigableIndexes())[e.length - 1])) i = e[e.length - 1];
            else
                for (var o in e) {
                    if (i < e[o]) {
                        i = t;
                        break;
                    }
                    t = e[o];
                }
            return i;
        }),
        (t.prototype.cleanUpEvents = function () {
            var e = this;
            e.options.autoplay && e.options.useAutoplayToggleButton && e.slideCount > 1 && e.$pauseButton.off("click.slick", e.autoPlayToggleHandler),
                e.options.dots && null !== e.$dots && i("li", e.$dots).off("click.slick", e.changeSlide).off("mouseenter.slick", i.proxy(e.interrupt, e, !0)).off("mouseleave.slick", i.proxy(e.interrupt, e, !1)),
                e.$slider.off("focus.slick blur.slick"),
                !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide), e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide)),
                e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler),
                e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler),
                e.$list.off("touchend.slick mouseup.slick", e.swipeHandler),
                e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler),
                e.$list.off("click.slick", e.clickHandler),
                i(document).off(e.visibilityChange, e.visibility),
                e.cleanUpSlideEvents(),
                i(window).off("orientationchange.slick.slick-" + e.instanceUid, e.orientationChange),
                i(window).off("resize.slick.slick-" + e.instanceUid, e.resize),
                i("[draggable!=true]", e.$slideTrack).off("dragstart", e.preventDefault),
                i(window).off("load.slick.slick-" + e.instanceUid, e.setPosition);
        }),
        (t.prototype.cleanUpSlideEvents = function () {
            var e = this;
            e.$list.off("mouseenter.slick", i.proxy(e.interrupt, e, !0)), e.$list.off("mouseleave.slick", i.proxy(e.interrupt, e, !1));
        }),
        (t.prototype.cleanUpRows = function () {
            var i,
                e = this;
            e.options.rows > 0 && ((i = e.$slides.children().children()).removeAttr("style"), e.$slider.empty().append(i));
        }),
        (t.prototype.clickHandler = function (i) {
            !1 === this.shouldClick && (i.stopImmediatePropagation(), i.stopPropagation(), i.preventDefault());
        }),
        (t.prototype.destroy = function (e) {
            var t = this;
            t.autoPlayClear(),
                (t.touchObject = {}),
                t.cleanUpEvents(),
                i(".slick-cloned", t.$slider).detach(),
                t.options.autoplay && t.options.useAutoplayToggleButton && t.slideCount > 1 && t.$pauseButton.remove(),
                t.$dots && t.$dots.remove(),
                t.$prevArrow && t.$prevArrow.length && (t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").prop("disabled", !1).css("display", ""), t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove()),
                t.$nextArrow && t.$nextArrow.length && (t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").prop("disabled", !1).css("display", ""), t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove()),
                t.$slides &&
                    (t.$slides
                        .removeClass("slick-slide slick-active slick-center slick-visible slick-current")
                        .removeAttr("aria-hidden")
                        .removeAttr("data-slick-index")
                        .each(function () {
                            i(this).attr("style", i(this).data("originalStyling"));
                        }),
                    t.$slideTrack.children(this.options.slide).detach(),
                    t.$slideTrack.detach(),
                    t.$list.detach(),
                    t.$slider.append(t.$slides)),
                t.cleanUpRows(),
                t.$slider.removeClass("slick-slider"),
                t.$slider.removeClass("slick-initialized"),
                t.$slider.removeClass("slick-dotted"),
                t.$slider.removeClass("accessible-slick"),
                (t.unslicked = !0),
                e || t.$slider.trigger("destroy", [t]);
        }),
        (t.prototype.disableTransition = function (i) {
            var e = this,
                t = {};
            (t[e.transitionType] = ""), !1 === e.options.fade ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t);
        }),
        (t.prototype.fadeSlide = function (i, e) {
            var t = this;
            !1 === t.cssTransitions
                ? (t.$slides.eq(i).css({ zIndex: t.options.zIndex }), t.$slides.eq(i).animate({ opacity: 1 }, t.options.speed, t.options.easing, e))
                : (t.applyTransition(i),
                  t.$slides.eq(i).css({ opacity: 1, zIndex: t.options.zIndex }),
                  e &&
                      setTimeout(function () {
                          t.disableTransition(i), e.call();
                      }, t.options.speed));
        }),
        (t.prototype.fadeSlideOut = function (i) {
            var e = this;
            !1 === e.cssTransitions ? e.$slides.eq(i).animate({ opacity: 0, zIndex: e.options.zIndex - 2 }, e.options.speed, e.options.easing) : (e.applyTransition(i), e.$slides.eq(i).css({ opacity: 0, zIndex: e.options.zIndex - 2 }));
        }),
        (t.prototype.filterSlides = t.prototype.slickFilter = function (i) {
            var e = this;
            null !== i && ((e.$slidesCache = e.$slides), e.unload(), e.$slideTrack.children(this.options.slide).detach(), e.$slidesCache.filter(i).appendTo(e.$slideTrack), e.reinit());
        }),
        (t.prototype.focusHandler = function () {
            var e = this;
            e.$slider
                .off("focus.slick blur.slick")
                .on("focus.slick", "*", function (t) {
                    var o = i(this);
                    setTimeout(function () {
                        e.options.pauseOnFocus && o.is(":focus") && ((e.focussed = !0), e.autoPlay());
                    }, 0);
                })
                .on("blur.slick", "*", function (t) {
                    i(this);
                    e.options.pauseOnFocus && ((e.focussed = !1), e.autoPlay());
                });
        }),
        (t.prototype.getCurrent = t.prototype.slickCurrentSlide = function () {
            return this.currentSlide;
        }),
        (t.prototype.getDotCount = function () {
            var i = this,
                e = 0,
                t = 0,
                o = 0;
            if (!0 === i.options.infinite)
                if (i.slideCount <= i.options.slidesToShow) ++o;
                else for (; e < i.slideCount; ) ++o, (e = t + i.options.slidesToScroll), (t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow);
            else if (!0 === i.options.centerMode) o = i.slideCount;
            else if (i.options.asNavFor) for (; e < i.slideCount; ) ++o, (e = t + i.options.slidesToScroll), (t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow);
            else o = 1 + Math.ceil((i.slideCount - i.options.slidesToShow) / i.options.slidesToScroll);
            return o - 1;
        }),
        (t.prototype.getLeft = function (i) {
            var e,
                t,
                o,
                s,
                n = this,
                l = 0;
            return (
                (n.slideOffset = 0),
                (t = n.$slides.first().outerHeight(!0)),
                !0 === n.options.infinite
                    ? (n.slideCount > n.options.slidesToShow &&
                          ((n.slideOffset = n.slideWidth * n.options.slidesToShow * -1),
                          (s = -1),
                          !0 === n.options.vertical && !0 === n.options.centerMode && (2 === n.options.slidesToShow ? (s = -1.5) : 1 === n.options.slidesToShow && (s = -2)),
                          (l = t * n.options.slidesToShow * s)),
                      n.slideCount % n.options.slidesToScroll != 0 &&
                          i + n.options.slidesToScroll > n.slideCount &&
                          n.slideCount > n.options.slidesToShow &&
                          (i > n.slideCount
                              ? ((n.slideOffset = (n.options.slidesToShow - (i - n.slideCount)) * n.slideWidth * -1), (l = (n.options.slidesToShow - (i - n.slideCount)) * t * -1))
                              : ((n.slideOffset = (n.slideCount % n.options.slidesToScroll) * n.slideWidth * -1), (l = (n.slideCount % n.options.slidesToScroll) * t * -1))))
                    : i + n.options.slidesToShow > n.slideCount && ((n.slideOffset = (i + n.options.slidesToShow - n.slideCount) * n.slideWidth), (l = (i + n.options.slidesToShow - n.slideCount) * t)),
                n.slideCount <= n.options.slidesToShow && ((n.slideOffset = 0), (l = 0)),
                !0 === n.options.centerMode && n.slideCount <= n.options.slidesToShow
                    ? (n.slideOffset = (n.slideWidth * Math.floor(n.options.slidesToShow)) / 2 - (n.slideWidth * n.slideCount) / 2)
                    : !0 === n.options.centerMode && !0 === n.options.infinite
                    ? (n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2) - n.slideWidth)
                    : !0 === n.options.centerMode && ((n.slideOffset = 0), (n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2))),
                (e = !1 === n.options.vertical ? i * n.slideWidth * -1 + n.slideOffset : i * t * -1 + l),
                !0 === n.options.variableWidth &&
                    ((o = n.slideCount <= n.options.slidesToShow || !1 === n.options.infinite ? n.$slideTrack.children(".slick-slide").eq(i) : n.$slideTrack.children(".slick-slide").eq(i + n.options.slidesToShow)),
                    (e = !0 === n.options.rtl ? (o[0] ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width()) : 0) : o[0] ? -1 * o[0].offsetLeft : 0),
                    !0 === n.options.centerMode &&
                        ((o = n.slideCount <= n.options.slidesToShow || !1 === n.options.infinite ? n.$slideTrack.children(".slick-slide").eq(i) : n.$slideTrack.children(".slick-slide").eq(i + n.options.slidesToShow + 1)),
                        (e = !0 === n.options.rtl ? (o[0] ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width()) : 0) : o[0] ? -1 * o[0].offsetLeft : 0),
                        (e += (n.$list.width() - o.outerWidth()) / 2))),
                e
            );
        }),
        (t.prototype.getOption = t.prototype.slickGetOption = function (i) {
            return this.options[i];
        }),
        (t.prototype.getNavigableIndexes = function () {
            var i,
                e = this,
                t = 0,
                o = 0,
                s = [];
            for (!1 === e.options.infinite ? (i = e.slideCount) : ((t = -1 * e.options.slidesToScroll), (o = -1 * e.options.slidesToScroll), (i = 2 * e.slideCount)); t < i; )
                s.push(t), (t = o + e.options.slidesToScroll), (o += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow);
            return s;
        }),
        (t.prototype.getSlick = function () {
            return this;
        }),
        (t.prototype.getSlideCount = function () {
            var e,
                t,
                o,
                s = this;
            return (
                (o = !0 === s.options.centerMode ? Math.floor(s.$list.width() / 2) : 0),
                (t = -1 * s.swipeLeft + o),
                !0 === s.options.swipeToSlide
                    ? (s.$slideTrack.find(".slick-slide").each(function (o, n) {
                          var l, r;
                          if (((l = i(n).outerWidth()), (r = n.offsetLeft), !0 !== s.options.centerMode && (r += l / 2), t < r + l)) return (e = n), !1;
                      }),
                      Math.abs(i(e).attr("data-slick-index") - s.currentSlide) || 1)
                    : s.options.slidesToScroll
            );
        }),
        (t.prototype.goTo = t.prototype.slickGoTo = function (i, e) {
            this.changeSlide({ data: { message: "index", index: parseInt(i) } }, e);
        }),
        (t.prototype.init = function (e) {
            var t = this;
            i(t.$slider).hasClass("slick-initialized") ||
                (i(t.$slider).addClass("slick-initialized"), t.buildRows(), t.buildOut(), t.setProps(), t.startLoad(), t.loadSlider(), t.initializeEvents(), t.updateArrows(), t.updateDots(), t.checkResponsive(!0), t.focusHandler()),
                e && t.$slider.trigger("init", [t]),
                t.options.autoplay && ((t.paused = !1), t.autoPlay()),
                t.updateSlideVisibility(),
                null != t.options.accessibility && console.warn("accessibility setting is no longer supported."),
                null != t.options.focusOnChange && console.warn("focusOnChange is no longer supported."),
                null != t.options.focusOnSelect && console.warn("focusOnSelect is no longer supported.");
        }),
        (t.prototype.initArrowEvents = function () {
            var i = this;
            !0 === i.options.arrows &&
                i.slideCount > i.options.slidesToShow &&
                (i.$prevArrow.off("click.slick").on("click.slick", { message: "previous" }, i.changeSlide), i.$nextArrow.off("click.slick").on("click.slick", { message: "next" }, i.changeSlide));
        }),
        (t.prototype.initDotEvents = function () {
            var e = this;
            !0 === e.options.dots && e.slideCount > e.options.slidesToShow && i("li", e.$dots).on("click.slick", { message: "index" }, e.changeSlide),
                !0 === e.options.dots && !0 === e.options.pauseOnDotsHover && e.slideCount > e.options.slidesToShow && i("li", e.$dots).on("mouseenter.slick", i.proxy(e.interrupt, e, !0)).on("mouseleave.slick", i.proxy(e.interrupt, e, !1));
        }),
        (t.prototype.initSlideEvents = function () {
            var e = this;
            e.options.pauseOnHover && (e.$list.on("mouseenter.slick", i.proxy(e.interrupt, e, !0)), e.$list.on("mouseleave.slick", i.proxy(e.interrupt, e, !1)));
        }),
        (t.prototype.initializeEvents = function () {
            var e = this;
            e.initArrowEvents(),
                e.initDotEvents(),
                e.initSlideEvents(),
                e.options.autoplay && e.options.useAutoplayToggleButton && e.slideCount > 1 && e.$pauseButton.on("click.slick", e.autoPlayToggleHandler),
                e.$list.on("touchstart.slick mousedown.slick", { action: "start" }, e.swipeHandler),
                e.$list.on("touchmove.slick mousemove.slick", { action: "move" }, e.swipeHandler),
                e.$list.on("touchend.slick mouseup.slick", { action: "end" }, e.swipeHandler),
                e.$list.on("touchcancel.slick mouseleave.slick", { action: "end" }, e.swipeHandler),
                e.$list.on("click.slick", e.clickHandler),
                i(document).on(e.visibilityChange, i.proxy(e.visibility, e)),
                i(window).on("orientationchange.slick.slick-" + e.instanceUid, i.proxy(e.orientationChange, e)),
                i(window).on("resize.slick.slick-" + e.instanceUid, i.proxy(e.resize, e)),
                i("[draggable!=true]", e.$slideTrack).on("dragstart", e.preventDefault),
                i(window).on("load.slick.slick-" + e.instanceUid, e.setPosition),
                i(e.setPosition);
        }),
        (t.prototype.initUI = function () {
            var i = this;
            !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.show(), i.$nextArrow.show()), !0 === i.options.dots && i.slideCount > i.options.slidesToShow && i.$dots.show();
        }),
        (t.prototype.lazyLoad = function () {
            var e,
                t,
                o,
                s = this;
            function n(e) {

                i("img[data-lazy]", e).each(function () {
                    var e = i(this),
                        t = i(this).attr("data-lazy"),
                        o = i(this).attr("data-srcset"),
                        n = i(this).attr("data-sizes") || s.$slider.attr("data-sizes"),
                        l = document.createElement("img");
                    (l.onload = function () {
                        e.animate({ opacity: 1 }, 100, function () {
                            o && (e.attr("srcset", o), n && e.attr("sizes", n)),
                                e.attr("src", t).animate({ opacity: 1 }, 200, function () {
                                    e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading");
                                }),
                                s.$slider.trigger("lazyLoaded", [s, e, t]);
                        });
                    }),
                        (l.onerror = function () {
                            e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), s.$slider.trigger("lazyLoadError", [s, e, t]);
                        }),
                        (l.src = t);
                });
            }
            if (
                (!0 === s.options.centerMode
                    ? !0 === s.options.infinite
                        ? (o = (t = s.currentSlide + (s.options.slidesToShow / 2 + 1)) + s.options.slidesToShow + 2)
                        : ((t = Math.max(0, s.currentSlide - (s.options.slidesToShow / 2 + 1))), (o = s.options.slidesToShow / 2 + 1 + 2 + s.currentSlide))
                    : ((t = s.options.infinite ? s.options.slidesToShow + s.currentSlide : s.currentSlide), (o = Math.ceil(t + s.options.slidesToShow)), !0 === s.options.fade && (t > 0 && t--, o <= s.slideCount && o++)),
                (e = s.$slider.find(".slick-slide").slice(t, o)),
                "anticipated" === s.options.lazyLoad)
            )
                for (var l = t - 1, r = o, a = s.$slider.find(".slick-slide"), d = 0; d < s.options.slidesToScroll; d++) l < 0 && (l = s.slideCount - 1), (e = (e = e.add(a.eq(l))).add(a.eq(r))), l--, r++;
            n(e),
                s.slideCount <= s.options.slidesToShow
                    ? n(s.$slider.find(".slick-slide"))
                    : s.currentSlide >= s.slideCount - s.options.slidesToShow
                    ? n(s.$slider.find(".slick-cloned").slice(0, s.options.slidesToShow))
                    : 0 === s.currentSlide && n(s.$slider.find(".slick-cloned").slice(-1 * s.options.slidesToShow));
        }),
        (t.prototype.loadSlider = function () {
            var i = this;
            i.setPosition(), i.$slideTrack.css({ opacity: 1 }), i.$slider.removeClass("slick-loading"), i.initUI(), "progressive" === i.options.lazyLoad && i.progressiveLazyLoad();
        }),
        (t.prototype.next = t.prototype.slickNext = function () {
            this.changeSlide({ data: { message: "next" } });
        }),
        (t.prototype.orientationChange = function () {
            this.checkResponsive(), this.setPosition();
        }),
        (t.prototype.pause = t.prototype.slickPause = function () {
            this.autoPlayClear(), (this.paused = !0);
        }),
        (t.prototype.play = t.prototype.slickPlay = function () {
            var i = this;
            i.autoPlay(), (i.options.autoplay = !0), (i.paused = !1), (i.focussed = !1), (i.interrupted = !1);
        }),
        (t.prototype.postSlide = function (i) {
            var e = this;
            e.unslicked || (e.$slider.trigger("afterChange", [e, i]), (e.animating = !1), e.slideCount > e.options.slidesToShow && e.setPosition(), (e.swipeLeft = null), e.options.autoplay && e.autoPlay(), e.updateSlideVisibility());
        }),
        (t.prototype.prev = t.prototype.slickPrev = function () {
            this.changeSlide({ data: { message: "previous" } });
        }),
        (t.prototype.preventDefault = function (i) {
            i.preventDefault();
        }),
        (t.prototype.progressiveLazyLoad = function (e) {
            e = e || 1;
            var t,
                o,
                s,
                n,
                l,
                r = this,
                a = i("img[data-lazy]", r.$slider);
            a.length
                ? ((t = a.first()),
                  (o = t.attr("data-lazy")),
                  (s = t.attr("data-srcset")),
                  (n = t.attr("data-sizes") || r.$slider.attr("data-sizes")),
                  ((l = document.createElement("img")).onload = function () {
                      s && (t.attr("srcset", s), n && t.attr("sizes", n)),
                          t.attr("src", o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),
                          !0 === r.options.adaptiveHeight && r.setPosition(),
                          r.$slider.trigger("lazyLoaded", [r, t, o]),
                          r.progressiveLazyLoad();
                  }),
                  (l.onerror = function () {
                      e < 3
                          ? setTimeout(function () {
                                r.progressiveLazyLoad(e + 1);
                            }, 500)
                          : (t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), r.$slider.trigger("lazyLoadError", [r, t, o]), r.progressiveLazyLoad());
                  }),
                  (l.src = o))
                : r.$slider.trigger("allImagesLoaded", [r]);
        }),
        (t.prototype.refresh = function (e) {
            var t,
                o,
                s = this;
            (o = s.slideCount - s.options.slidesToShow),
                !s.options.infinite && s.currentSlide > o && (s.currentSlide = o),
                s.slideCount <= s.options.slidesToShow && (s.currentSlide = 0),
                (t = s.currentSlide),
                s.destroy(!0),
                i.extend(s, s.initials, { currentSlide: t }),
                s.init(),
                e || s.changeSlide({ data: { message: "index", index: t } }, !1);
        }),
        (t.prototype.registerBreakpoints = function () {
            var e,
                t,
                o,
                s = this,
                n = s.options.responsive || null;
            if ("array" === i.type(n) && n.length) {
                for (e in ((s.respondTo = s.options.respondTo || "window"), n))
                    if (((o = s.breakpoints.length - 1), n.hasOwnProperty(e))) {
                        for (t = n[e].breakpoint; o >= 0; ) s.breakpoints[o] && s.breakpoints[o] === t && s.breakpoints.splice(o, 1), o--;
                        s.breakpoints.push(t), (s.breakpointSettings[t] = n[e].settings);
                    }
                s.breakpoints.sort(function (i, e) {
                    return s.options.mobileFirst ? i - e : e - i;
                });
            }
        }),
        (t.prototype.reinit = function () {
            var i = this;
            (i.$slides = i.$slideTrack.children(i.options.slide).addClass("slick-slide")),
                (i.slideCount = i.$slides.length),
                i.currentSlide >= i.slideCount && 0 !== i.currentSlide && (i.currentSlide = i.currentSlide - i.options.slidesToScroll),
                i.slideCount <= i.options.slidesToShow && (i.currentSlide = 0),
                i.registerBreakpoints(),
                i.setProps(),
                i.setupInfinite(),
                i.buildArrows(),
                i.updateArrows(),
                i.initArrowEvents(),
                i.buildDots(),
                i.updateDots(),
                i.initDotEvents(),
                i.cleanUpSlideEvents(),
                i.initSlideEvents(),
                i.checkResponsive(!1, !0),
                i.setSlideClasses("number" == typeof i.currentSlide ? i.currentSlide : 0),
                i.setPosition(),
                i.focusHandler(),
                (i.paused = !i.options.autoplay),
                i.autoPlay(),
                i.$slider.trigger("reInit", [i]);
        }),
        (t.prototype.resize = function () {
            var e = this;
            i(window).width() !== e.windowWidth &&
                (clearTimeout(e.windowDelay),
                (e.windowDelay = window.setTimeout(function () {
                    (e.windowWidth = i(window).width()), e.checkResponsive(), e.unslicked || e.setPosition();
                }, 50)));
        }),
        (t.prototype.removeSlide = t.prototype.slickRemove = function (i, e, t) {
            var o = this;
            if (((i = "boolean" == typeof i ? (!0 === (e = i) ? 0 : o.slideCount - 1) : !0 === e ? --i : i), o.slideCount < 1 || i < 0 || i > o.slideCount - 1)) return !1;
            o.unload(),
                !0 === t ? o.$slideTrack.children().remove() : o.$slideTrack.children(this.options.slide).eq(i).remove(),
                (o.$slides = o.$slideTrack.children(this.options.slide)),
                o.$slideTrack.children(this.options.slide).detach(),
                o.$slideTrack.append(o.$slides),
                (o.$slidesCache = o.$slides),
                o.reinit();
        }),
        (t.prototype.setCSS = function (i) {
            var e,
                t,
                o = this,
                s = {};
            !0 === o.options.rtl && (i = -i),
                (e = "left" == o.positionProp ? Math.ceil(i) + "px" : "0px"),
                (t = "top" == o.positionProp ? Math.ceil(i) + "px" : "0px"),
                (s[o.positionProp] = i),
                !1 === o.transformsEnabled
                    ? o.$slideTrack.css(s)
                    : ((s = {}), !1 === o.cssTransitions ? ((s[o.animType] = "translate(" + e + ", " + t + ")"), o.$slideTrack.css(s)) : ((s[o.animType] = "translate3d(" + e + ", " + t + ", 0px)"), o.$slideTrack.css(s)));
        }),
        (t.prototype.setDimensions = function () {
            var i = this;
            !1 === i.options.vertical
                ? !0 === i.options.centerMode && i.$list.css({ padding: "0px " + i.options.centerPadding })
                : (i.$list.height(i.$slides.first().outerHeight(!0) * i.options.slidesToShow), !0 === i.options.centerMode && i.$list.css({ padding: i.options.centerPadding + " 0px" })),
                (i.listWidth = i.$list.width()),
                (i.listHeight = i.$list.height()),
                !1 === i.options.vertical && !1 === i.options.variableWidth
                    ? ((i.slideWidth = Math.ceil(i.listWidth / i.options.slidesToShow)), i.$slideTrack.width(Math.ceil(i.slideWidth * i.$slideTrack.children(".slick-slide").length)))
                    : !0 === i.options.variableWidth
                    ? i.$slideTrack.width(5e3 * i.slideCount)
                    : ((i.slideWidth = Math.ceil(i.listWidth)), i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0) * i.$slideTrack.children(".slick-slide").length)));
            var e = i.$slides.first().outerWidth(!0) - i.$slides.first().width();
            !1 === i.options.variableWidth && i.$slideTrack.children(".slick-slide").width(i.slideWidth - e);
        }),
        (t.prototype.setFade = function () {
            var e,
                t = this;
            t.$slides.each(function (o, s) {
                (e = t.slideWidth * o * -1),
                    !0 === t.options.rtl ? i(s).css({ position: "relative", right: e, top: 0, zIndex: t.options.zIndex - 2, opacity: 0 }) : i(s).css({ position: "relative", left: e, top: 0, zIndex: t.options.zIndex - 2, opacity: 0 });
            }),
                t.$slides.eq(t.currentSlide).css({ zIndex: t.options.zIndex - 1, opacity: 1 });
        }),
        (t.prototype.setHeight = function () {
            var i = this;
            if (1 === i.options.slidesToShow && !0 === i.options.adaptiveHeight && !1 === i.options.vertical) {
                var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
                i.$list.css("height", e);
            }
        }),
        (t.prototype.setOption = t.prototype.slickSetOption = function () {
            var e,
                t,
                o,
                s,
                n,
                l = this,
                r = !1;
            if (
                ("object" === i.type(arguments[0])
                    ? ((o = arguments[0]), (r = arguments[1]), (n = "multiple"))
                    : "string" === i.type(arguments[0]) &&
                      ((o = arguments[0]), (s = arguments[1]), (r = arguments[2]), "responsive" === arguments[0] && "array" === i.type(arguments[1]) ? (n = "responsive") : void 0 !== arguments[1] && (n = "single")),
                "single" === n)
            )
                l.options[o] = s;
            else if ("multiple" === n)
                i.each(o, function (i, e) {
                    l.options[i] = e;
                });
            else if ("responsive" === n)
                for (t in s)
                    if ("array" !== i.type(l.options.responsive)) l.options.responsive = [s[t]];
                    else {
                        for (e = l.options.responsive.length - 1; e >= 0; ) l.options.responsive[e].breakpoint === s[t].breakpoint && l.options.responsive.splice(e, 1), e--;
                        l.options.responsive.push(s[t]);
                    }
            r && (l.unload(), l.reinit());
        }),
        (t.prototype.setPosition = function () {
            var i = this;
            i.setDimensions(), i.setHeight(), !1 === i.options.fade ? i.setCSS(i.getLeft(i.currentSlide)) : i.setFade(), i.$slider.trigger("setPosition", [i]);
        }),
        (t.prototype.setProps = function () {
            var i = this,
                e = document.body.style;
            (i.positionProp = !0 === i.options.vertical ? "top" : "left"),
                "top" === i.positionProp ? i.$slider.addClass("slick-vertical") : i.$slider.removeClass("slick-vertical"),
                (void 0 === e.WebkitTransition && void 0 === e.MozTransition && void 0 === e.msTransition) || (!0 === i.options.useCSS && (i.cssTransitions = !0)),
                i.options.fade && ("number" == typeof i.options.zIndex ? i.options.zIndex < 3 && (i.options.zIndex = 3) : (i.options.zIndex = i.defaults.zIndex)),
                void 0 !== e.OTransform && ((i.animType = "OTransform"), (i.transformType = "-o-transform"), (i.transitionType = "OTransition"), void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)),
                void 0 !== e.MozTransform && ((i.animType = "MozTransform"), (i.transformType = "-moz-transform"), (i.transitionType = "MozTransition"), void 0 === e.perspectiveProperty && void 0 === e.MozPerspective && (i.animType = !1)),
                void 0 !== e.webkitTransform &&
                    ((i.animType = "webkitTransform"), (i.transformType = "-webkit-transform"), (i.transitionType = "webkitTransition"), void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)),
                void 0 !== e.msTransform && ((i.animType = "msTransform"), (i.transformType = "-ms-transform"), (i.transitionType = "msTransition"), void 0 === e.msTransform && (i.animType = !1)),
                void 0 !== e.transform && !1 !== i.animType && ((i.animType = "transform"), (i.transformType = "transform"), (i.transitionType = "transition")),
                (i.transformsEnabled = i.options.useTransform && null !== i.animType && !1 !== i.animType);
        }),
        (t.prototype.setSlideClasses = function (e) {
            var t,
                o,
                s,
                n,
                l = this;
            if (
                ((o = l.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true")),
                !1 !== l.options.useGroupRole &&
                    !0 === l.options.centerMode &&
                    o.attr("aria-label", function () {
                        return i(this).attr("aria-label").replace(" (centered)", "");
                    }),
                l.$slides.eq(e).addClass("slick-current"),
                !0 === l.options.centerMode)
            ) {
                var r = l.options.slidesToShow % 2 == 0 ? 1 : 0;
                (t = Math.floor(l.options.slidesToShow / 2)),
                    !0 === l.options.infinite &&
                        (e >= t && e <= l.slideCount - 1 - t
                            ? l.$slides
                                  .slice(e - t + r, e + t + 1)
                                  .addClass("slick-active")
                                  .removeAttr("aria-hidden")
                            : ((s = l.options.slidesToShow + e),
                              o
                                  .slice(s - t + 1 + r, s + t + 2)
                                  .addClass("slick-active")
                                  .removeAttr("aria-hidden")),
                        0 === e
                            ? o
                                  .eq(l.options.slidesToShow + l.slideCount + 1)
                                  .addClass("slick-center")
                                  .attr("aria-label", function () {
                                      return i(this).attr("aria-label") + " (centered)";
                                  })
                            : e === l.slideCount - 1 &&
                              o
                                  .eq(l.options.slidesToShow)
                                  .addClass("slick-center")
                                  .attr("aria-label", function () {
                                      return i(this).attr("aria-label") + " (centered)";
                                  })),
                    l.$slides
                        .eq(e)
                        .addClass("slick-center")
                        .attr("aria-label", function () {
                            return i(this).attr("aria-label") + " (centered)";
                        });
            } else
                e >= 0 && e <= l.slideCount - l.options.slidesToShow
                    ? l.$slides
                          .slice(e, e + l.options.slidesToShow)
                          .addClass("slick-active")
                          .removeAttr("aria-hidden")
                    : o.length <= l.options.slidesToShow
                    ? o.addClass("slick-active").removeAttr("aria-hidden")
                    : ((n = l.slideCount % l.options.slidesToShow),
                      (s = !0 === l.options.infinite ? l.options.slidesToShow + e : e),
                      l.options.slidesToShow == l.options.slidesToScroll && l.slideCount - e < l.options.slidesToShow
                          ? o
                                .slice(s - (l.options.slidesToShow - n), s + n)
                                .addClass("slick-active")
                                .removeAttr("aria-hidden")
                          : o
                                .slice(s, s + l.options.slidesToShow)
                                .addClass("slick-active")
                                .removeAttr("aria-hidden"));
            ("ondemand" !== l.options.lazyLoad && "anticipated" !== l.options.lazyLoad) || l.lazyLoad();
        }),
        (t.prototype.setupInfinite = function () {
            var e,
                t,
                o,
                s = this;
            if ((!0 === s.options.fade && (s.options.centerMode = !1), !0 === s.options.infinite && !1 === s.options.fade && ((t = null), s.slideCount > s.options.slidesToShow))) {
                for (o = !0 === s.options.centerMode ? s.options.slidesToShow + 1 : s.options.slidesToShow, e = s.slideCount; e > s.slideCount - o; e -= 1)
                    (t = e - 1),
                        i(s.$slides[t])
                            .clone(!0)
                            .removeAttr("id")
                            .attr("data-slick-index", t - s.slideCount)
                            .prependTo(s.$slideTrack)
                            .addClass("slick-cloned");
                for (e = 0; e < o + s.slideCount; e += 1)
                    (t = e),
                        i(s.$slides[t])
                            .clone(!0)
                            .removeAttr("id")
                            .attr("data-slick-index", t + s.slideCount)
                            .appendTo(s.$slideTrack)
                            .addClass("slick-cloned");
                s.$slideTrack
                    .find(".slick-cloned")
                    .find("[id]")
                    .each(function () {
                        i(this).removeAttr("id");
                    });
            }
        }),
        (t.prototype.interrupt = function (i) {
            i || this.autoPlay(), (this.interrupted = i);
        }),
        (t.prototype.selectHandler = function (e) {
            var t = this,
                o = i(e.target).is(".slick-slide") ? i(e.target) : i(e.target).parents(".slick-slide"),
                s = parseInt(o.attr("data-slick-index"));
            s || (s = 0), t.slideCount <= t.options.slidesToShow ? t.slideHandler(s, !1, !0) : t.slideHandler(s);
        }),
        (t.prototype.slideHandler = function (i, e, t) {
            var o,
                s,
                n,
                l,
                r,
                a,
                d = this;
            if (((e = e || !1), !((!0 === d.animating && !0 === d.options.waitForAnimate) || (!0 === d.options.fade && d.currentSlide === i))))
                if (
                    (!1 === e && d.asNavFor(i),
                    (o = i),
                    (r = d.getLeft(o)),
                    (l = d.getLeft(d.currentSlide)),
                    (d.currentLeft = null === d.swipeLeft ? l : d.swipeLeft),
                    !1 === d.options.infinite && !1 === d.options.centerMode && (i < 0 || i > d.getDotCount() * d.options.slidesToScroll))
                )
                    !1 === d.options.fade &&
                        ((o = d.currentSlide),
                        !0 !== t && d.slideCount > d.options.slidesToShow
                            ? d.animateSlide(l, function () {
                                  d.postSlide(o);
                              })
                            : d.postSlide(o));
                else if (!1 === d.options.infinite && !0 === d.options.centerMode && (i < 0 || i > d.slideCount - d.options.slidesToScroll))
                    !1 === d.options.fade &&
                        ((o = d.currentSlide),
                        !0 !== t && d.slideCount > d.options.slidesToShow
                            ? d.animateSlide(l, function () {
                                  d.postSlide(o);
                              })
                            : d.postSlide(o));
                else {
                    if (
                        (d.options.autoplay && clearInterval(d.autoPlayTimer),
                        (s =
                            o < 0
                                ? d.slideCount % d.options.slidesToScroll != 0
                                    ? d.slideCount - (d.slideCount % d.options.slidesToScroll)
                                    : d.slideCount + o
                                : o >= d.slideCount
                                ? d.slideCount % d.options.slidesToScroll != 0
                                    ? 0
                                    : o - d.slideCount
                                : o),
                        (d.animating = !0),
                        d.$slider.trigger("beforeChange", [d, d.currentSlide, s]),
                        (n = d.currentSlide),
                        (d.currentSlide = s),
                        d.setSlideClasses(d.currentSlide),
                        d.options.asNavFor && (a = (a = d.getNavTarget()).slick("getSlick")).slideCount <= a.options.slidesToShow && a.setSlideClasses(d.currentSlide),
                        d.updateDots(),
                        d.updateArrows(),
                        !0 === d.options.fade)
                    )
                        return (
                            !0 !== t
                                ? (d.fadeSlideOut(n),
                                  d.fadeSlide(s, function () {
                                      d.postSlide(s);
                                  }))
                                : d.postSlide(s),
                            void d.animateHeight()
                        );
                    !0 !== t && d.slideCount > d.options.slidesToShow
                        ? d.animateSlide(r, function () {
                              d.postSlide(s);
                          })
                        : d.postSlide(s);
                }
        }),
        (t.prototype.startLoad = function () {
            var i = this;
            !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.hide(), i.$nextArrow.hide()),
                !0 === i.options.dots && i.slideCount > i.options.slidesToShow && i.$dots.hide(),
                i.$slider.addClass("slick-loading");
        }),
        (t.prototype.swipeDirection = function () {
            var i,
                e,
                t,
                o,
                s = this;
            return (
                (i = s.touchObject.startX - s.touchObject.curX),
                (e = s.touchObject.startY - s.touchObject.curY),
                (t = Math.atan2(e, i)),
                (o = Math.round((180 * t) / Math.PI)) < 0 && (o = 360 - Math.abs(o)),
                (o <= 45 && o >= 0) || (o <= 360 && o >= 315)
                    ? !1 === s.options.rtl
                        ? "left"
                        : "right"
                    : o >= 135 && o <= 225
                    ? !1 === s.options.rtl
                        ? "right"
                        : "left"
                    : !0 === s.options.verticalSwiping
                    ? o >= 35 && o <= 135
                        ? "down"
                        : "up"
                    : "vertical"
            );
        }),
        (t.prototype.swipeEnd = function (i) {
            var e,
                t,
                o = this;
            if (((o.dragging = !1), (o.swiping = !1), o.scrolling)) return (o.scrolling = !1), !1;
            if (((o.interrupted = !1), (o.shouldClick = !(o.touchObject.swipeLength > 10)), void 0 === o.touchObject.curX)) return !1;
            if ((!0 === o.touchObject.edgeHit && o.$slider.trigger("edge", [o, o.swipeDirection()]), o.touchObject.swipeLength >= o.touchObject.minSwipe)) {
                switch ((t = o.swipeDirection())) {
                    case "left":
                    case "down":
                        (e = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide + o.getSlideCount()) : o.currentSlide + o.getSlideCount()), (o.currentDirection = 0);
                        break;
                    case "right":
                    case "up":
                        (e = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide - o.getSlideCount()) : o.currentSlide - o.getSlideCount()), (o.currentDirection = 1);
                }
                "vertical" != t && (o.slideHandler(e), (o.touchObject = {}), o.$slider.trigger("swipe", [o, t]));
            } else o.touchObject.startX !== o.touchObject.curX && (o.slideHandler(o.currentSlide), (o.touchObject = {}));
        }),
        (t.prototype.swipeHandler = function (i) {
            var e = this;
            if (!(!1 === e.options.swipe || ("ontouchend" in document && !1 === e.options.swipe) || (!1 === e.options.draggable && -1 !== i.type.indexOf("mouse"))))
                switch (
                    ((e.touchObject.fingerCount = i.originalEvent && void 0 !== i.originalEvent.touches ? i.originalEvent.touches.length : 1),
                    (e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold),
                    !0 === e.options.verticalSwiping && (e.touchObject.minSwipe = e.listHeight / e.options.touchThreshold),
                    i.data.action)
                ) {
                    case "start":
                        e.swipeStart(i);
                        break;
                    case "move":
                        e.swipeMove(i);
                        break;
                    case "end":
                        e.swipeEnd(i);
                }
        }),
        (t.prototype.swipeMove = function (i) {
            var e,
                t,
                o,
                s,
                n,
                l,
                r = this;
            return (
                (n = void 0 !== i.originalEvent ? i.originalEvent.touches : null),
                !(!r.dragging || r.scrolling || (n && 1 !== n.length)) &&
                    ((e = r.getLeft(r.currentSlide)),
                    (r.touchObject.curX = void 0 !== n ? n[0].pageX : i.clientX),
                    (r.touchObject.curY = void 0 !== n ? n[0].pageY : i.clientY),
                    (r.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(r.touchObject.curX - r.touchObject.startX, 2)))),
                    (l = Math.round(Math.sqrt(Math.pow(r.touchObject.curY - r.touchObject.startY, 2)))),
                    !r.options.verticalSwiping && !r.swiping && l > 4
                        ? ((r.scrolling = !0), !1)
                        : (!0 === r.options.verticalSwiping && (r.touchObject.swipeLength = l),
                          (t = r.swipeDirection()),
                          void 0 !== i.originalEvent && r.touchObject.swipeLength > 4 && ((r.swiping = !0), i.preventDefault()),
                          (s = (!1 === r.options.rtl ? 1 : -1) * (r.touchObject.curX > r.touchObject.startX ? 1 : -1)),
                          !0 === r.options.verticalSwiping && (s = r.touchObject.curY > r.touchObject.startY ? 1 : -1),
                          (o = r.touchObject.swipeLength),
                          (r.touchObject.edgeHit = !1),
                          !1 === r.options.infinite &&
                              ((0 === r.currentSlide && "right" === t) || (r.currentSlide >= r.getDotCount() && "left" === t)) &&
                              ((o = r.touchObject.swipeLength * r.options.edgeFriction), (r.touchObject.edgeHit = !0)),
                          !1 === r.options.vertical ? (r.swipeLeft = e + o * s) : (r.swipeLeft = e + o * (r.$list.height() / r.listWidth) * s),
                          !0 === r.options.verticalSwiping && (r.swipeLeft = e + o * s),
                          !0 !== r.options.fade && !1 !== r.options.touchMove && (!0 === r.animating ? ((r.swipeLeft = null), !1) : void r.setCSS(r.swipeLeft))))
            );
        }),
        (t.prototype.swipeStart = function (i) {
            var e,
                t = this;
            if (((t.interrupted = !0), 1 !== t.touchObject.fingerCount || t.slideCount <= t.options.slidesToShow)) return (t.touchObject = {}), !1;
            void 0 !== i.originalEvent && void 0 !== i.originalEvent.touches && (e = i.originalEvent.touches[0]),
                (t.touchObject.startX = t.touchObject.curX = void 0 !== e ? e.pageX : i.clientX),
                (t.touchObject.startY = t.touchObject.curY = void 0 !== e ? e.pageY : i.clientY),
                (t.dragging = !0);
        }),
        (t.prototype.unfilterSlides = t.prototype.slickUnfilter = function () {
            var i = this;
            null !== i.$slidesCache && (i.unload(), i.$slideTrack.children(this.options.slide).detach(), i.$slidesCache.appendTo(i.$slideTrack), i.reinit());
        }),
        (t.prototype.unload = function () {
            var e = this;
            i(".slick-cloned", e.$slider).remove(),
                e.$dots && e.$dots.remove(),
                e.$prevArrow && e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.remove(),
                e.$nextArrow && e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.remove(),
                e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "");
        }),
        (t.prototype.unslick = function (i) {
            var e = this;
            e.$slider.trigger("unslick", [e, i]), e.destroy();
        }),
        (t.prototype.updateArrows = function () {
            var i = this;
            Math.floor(i.options.slidesToShow / 2),
                !0 === i.options.arrows &&
                    i.slideCount > i.options.slidesToShow &&
                    !i.options.infinite &&
                    (i.$prevArrow.removeClass("slick-disabled").prop("disabled", !1),
                    i.$nextArrow.removeClass("slick-disabled").prop("disabled", !1),
                    0 === i.currentSlide
                        ? (document.activeElement === i.$prevArrow.get(0) && i.$slider.get(0).focus(), i.$prevArrow.addClass("slick-disabled").prop("disabled", !0), i.$nextArrow.removeClass("slick-disabled").prop("disabled", !1))
                        : ((i.currentSlide >= i.slideCount - i.options.slidesToShow && !1 === i.options.centerMode) || (i.currentSlide >= i.slideCount - 1 && !0 === i.options.centerMode)) &&
                          (document.activeElement === i.$nextArrow.get(0) && i.$slider.get(0).focus(), i.$nextArrow.addClass("slick-disabled").prop("disabled", !0), i.$prevArrow.removeClass("slick-disabled").prop("disabled", !1)));
        }),
        (t.prototype.updateDots = function () {
            var i = this;
            null !== i.$dots &&
                (i.$dots.find("li").removeClass("slick-active").find("button").removeAttr("aria-current").end().end(),
                i.$dots
                    .find("li")
                    .eq(Math.floor(i.currentSlide / i.options.slidesToScroll))
                    .addClass("slick-active")
                    .find("button")
                    .attr("aria-current", !0)
                    .end()
                    .end());
        }),
        (t.prototype.updateSlideVisibility = function () {
            this.$slideTrack.find(".slick-slide").attr("aria-hidden", "true").find("a, input, button, select").attr("tabindex", "-1"),
                this.$slideTrack.find(".slick-active").removeAttr("aria-hidden").find("a, input, button, select").removeAttr("tabindex");
        }),
        (t.prototype.visibility = function () {
            var i = this;
            i.options.autoplay && (document[i.hidden] ? (i.interrupted = !0) : (i.interrupted = !1));
        }),
        (i.fn.slick = function () {
            var i,
                e,
                o = this,
                s = arguments[0],
                n = Array.prototype.slice.call(arguments, 1),
                l = o.length;
            for (i = 0; i < l; i++) if (("object" == typeof s || void 0 === s ? (o[i].slick = new t(o[i], s)) : (e = o[i].slick[s].apply(o[i].slick, n)), void 0 !== e)) return e;
            return o;
        });
});
